import { ACTIVE_COLOR, CHAPTER_STATUS_LEGEND, NA_COLOR } from '../omnidashboard.config';
import { MetricData, MetricSummaryBucket, OmniMetricDefinition } from '../omnidashboard.models';

const DEFAULT_NA_METRIC: MetricData = {
  displayValue: 'N/A',
  color: NA_COLOR,
  value: null,
  signedCount: 0,
};

const CHAPTER_STATUS_BUCKETS: MetricSummaryBucket[] = [
  { value: 'Active', label: 'Active', color: ACTIVE_COLOR, iconClass: 'fa-check', tooltip: 'Chapter is active and has at least one member' },
];

export const CHAPTER_STATUS_METRIC: OmniMetricDefinition = {
  key: 'chapter-status',
  label: 'Chapter Status',
  legend: CHAPTER_STATUS_LEGEND,
  summaryBuckets: CHAPTER_STATUS_BUCKETS,
  naMetric: DEFAULT_NA_METRIC,
};
